'use client';
var styles = {"article":"ModalFrame-module_article__bYPLK","button-close":"ModalFrame-module_button-close__n-ReH","animation":"ModalFrame-module_animation__d2kjF","type-top":"ModalFrame-module_type-top__L7M20","type-bottom":"ModalFrame-module_type-bottom__COPPc"};

export { styles as default };
